import { FC, useState, useEffect } from "react";
import Button from "../../../components/UI/Button/Button";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import {
  BreadCrumbs,
  ActiveStatus,
  DeactiveStatus,
  DotIcon,
  Container,
  TableContainer,
  TemplateDataId,
  TemplateHeader,
  TemplateHeadingId,
  TemplateLineItem,
  TemplateTable,
  Th,
  PublishBtn,
} from "./StyledLotteryGame";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../../../components/Modal/Modal";

import {
  getTemplateList,
  publishLottery,
} from "../../../features/templateListslice";

import {
  LotteryOptionsList,
  LotteryOption,
  LotteryTypeTitle,
} from "../LotteryList/StyledLottery";
import { RootState } from "../../../app/Store";
import { convertToUTC, transformTimeWithAMPM } from "../../../Utility/Utility";
import { useNavigate } from "react-router-dom";
import { adminRouts } from "../../../routs";
import JsonToCsv from "../../../components/JSONToCSV/JsonToCsv";

import oneTimeLotteryImgSrc from "../../../assets/images/oneTimeLottery.svg";
import repeatedLotteryImgSrc from "../../../assets/images/repeatedLottery.svg";
import useDimension from "../../../costomHook/useDimention";
import * as UIConstants from "../../../UIConstants";
import { setUpdateStatus } from "../../../features/updateTemplateSlice";
import ButtonComponent from "../../../components/UI/Buttons/Button";
import {
  ButtonType,
  ButtonVariant as BtnVariant,
  ButtonSizeVariant,
  AppButtonType,
} from "../../../Utility/InterFacesAndEnum";

const weekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thrusday",
  "Friday",
  "Saturday",
];
enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
}

const LotteryTemplateList = () => {
  const { width } = useDimension();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let mainList = useSelector(
    (state: RootState) => state.templateList.templateList
  );
  let templateList = [...mainList].reverse();
  console.log(templateList);
  const [createLotteryModal, setCreateLotteryModalStatus] = useState(false);

  useEffect(() => {
    dispatch(getTemplateList());
    dispatch(setUpdateStatus({ isUpdate: false }));
  }, []);

  const redirectToTemplateList = (id: number, isRepeatLottery: boolean) => {
    if (isRepeatLottery) {
      navigate(`/admin/lottery/update-template/${id}`);
    } else {
      navigate(`/admin/lottery/update-onetime-template/${id}`);
    }
  };

  const publishTemplate = (id: number) => {
    dispatch(publishLottery({ templateId: id }));
  };

  const redirectToCreateLottery = (type: number): void => {
    if (type === 1) {
      navigate(adminRouts.createOneTimeLottery);
    } else {
      navigate(adminRouts.createRepeatedLottery);
    }
  };

  return (
    <>
      <Modal
        isOpen={createLotteryModal}
        name={"Create lottery option modal"}
        title={"Create Lottery"}
        toggleModal={() => {
          setCreateLotteryModalStatus(!createLotteryModal);
        }}
      >
        <LotteryOptionsList>
          <LotteryOption
            onClick={() => {
              redirectToCreateLottery(1);
            }}
          >
            <img src={oneTimeLotteryImgSrc} />
            <LotteryTypeTitle>One time Lottery</LotteryTypeTitle>
          </LotteryOption>
          <LotteryOption
            onClick={() => {
              redirectToCreateLottery(2);
            }}
          >
            <img src={repeatedLotteryImgSrc} />
            <LotteryTypeTitle>Repeated Lottery</LotteryTypeTitle>
          </LotteryOption>
        </LotteryOptionsList>
      </Modal>
      <BreadCrumbs>
        <ViewHeader
          title={"Lottery Templates"}
          isNeedCreateButton={false}
          btnText={"Test button"}
          routePath={"/"}
        />

        <span>
          <span style={{ marginRight: "10px" }}>
            <JsonToCsv data={templateList} fileLabel={"templates"} />
          </span>
          <Button
            title={"+ Create"}
            btnSize={
              width <= UIConstants.mobileWidth ? ButtonSize.sm : ButtonSize.md
            }
            btnVariant={ButtonVariant.primaryFilled}
            clicked={() => {
              setCreateLotteryModalStatus(true);
            }}
          />
        </span>

        {/* <span>
          <span style={{ marginRight: "10px" }}>
            <JsonToCsv data={templateList} fileLabel={"templates"} />
          </span>
          <Button
            title={"+ Create Lottery"}
            btnSize={ButtonSize.md}
            btnVariant={ButtonVariant.primaryFilled}
            clicked={() => {
              setCreateLotteryModalStatus(true);
            }}
          />
        </span> */}
      </BreadCrumbs>

      <Container>
        <TableContainer>
          <TemplateTable>
            <TemplateHeader>
              <TemplateHeadingId>Template ID</TemplateHeadingId>
              <Th>Lottery Reward</Th>
              <Th>Lottery Type</Th>
              <Th>Start Date/ Day</Th>
              <Th>End Date/ Day</Th>
              <Th>Lottery Status</Th>
              <Th>Action</Th>
            </TemplateHeader>

            {templateList.map((templateObj: any) => {
              // console.log(templateObj)
              return (
                <TemplateLineItem>
                  <TemplateDataId
                    className="templateId"
                    onClick={() => {
                      redirectToTemplateList(
                        templateObj.lotteryId,
                        templateObj.isRepeat
                      );
                    }}
                  >
                    {templateObj.lotteryId}
                  </TemplateDataId>
                  <td>
                    {templateObj.rewardType === "M"
                      ? `${
                          templateObj.rewardAmount
                            ? "$ " + templateObj.rewardAmount
                            : "$ 0"
                        }`
                      : templateObj.rewardGiftName}
                  </td>
                  <td>
                    {templateObj.isRepeat
                      ? "Repeated Lottery"
                      : "One Time Lottery"}
                  </td>
                  <td>
                    {templateObj.isRepeat
                      ? weekNames[templateObj.lotteryStartDay - 1]
                      : convertToUTC(
                          templateObj.lotteryStartDate,
                          templateObj.lotteryStartTime
                        )}
                  </td>
                  <td>
                    {templateObj.isRepeat
                      ? weekNames[templateObj.lotteryEndDay - 1]
                      : convertToUTC(
                          templateObj.lotteryEndDate,
                          templateObj.lotteryEndTime
                        )}
                  </td>
                  <td>
                    {templateObj.isActive ? (
                      <ActiveStatus>
                        <DotIcon />
                        Active
                      </ActiveStatus>
                    ) : (
                      <DeactiveStatus>
                        <DotIcon />
                        Disabled
                      </DeactiveStatus>
                    )}
                  </td>
                  <td>
                   <PublishBtn>
                   <ButtonComponent
                      disabled={templateObj?.isLotteryGameCreated}
                      fullWidth={false}
                      type={ButtonType.default}
                      variant={BtnVariant.outlined}
                      clicked={() => publishTemplate(templateObj.lotteryId)}
                      size={ButtonSizeVariant.medium}
                      appBtnType={AppButtonType.primaryBordered}
                    >
                      {templateObj?.isLotteryGameCreated
                        ? "Published"
                        : "Publish"}
                    </ButtonComponent>
                   </PublishBtn>

                    
                  </td>
                </TemplateLineItem>
              );
            })}
          </TemplateTable>
        </TableContainer>
      </Container>
    </>
  );
};

export default LotteryTemplateList;
